import { CalendarIcon, DatePicker } from "@mui/x-date-pickers";
import PropTypes from "prop-types";
import { useState } from "react";

import { ArrowLeftIcon, ArrowRightIcon } from "src/components/icons/ArrowIcons";
import { TodayIcon } from "src/components/icons/TodayIcon";
import GridSettingsBar_Button from "./GridSettingsBar_Button";
import { IconWithText } from "src/components/icons/purposed/IconWithText";
import { pvmStringLong } from "src/components/js/statics1";

export default function GridDateSelector({
  time,
  setTime,
  dense = false,
  prevText = "EDELLINEN",
  nextText = "SEURAAVA",
  disabled = false,
  variant = "outlined",
  size = "medium",
  noPrint = false,
}) {
  const [open, setOpen] = useState(false);

  //const starttime = time?.starttime;

  const setStartTime = (starttime) => {
    const endtime = new Date(starttime);
    endtime.setHours(23, 59, 59, 999);
    setTime({ starttime: starttime, endtime: endtime });
  };
  const nav1Day = (dir) => {
    const newTime = new Date(time?.starttime);
    newTime.setDate(newTime.getDate() + dir);
    setStartTime(newTime);
  };
  const navToToday = () => {
    // select today date with time 0
    const newTime = new Date();
    newTime.setHours(0, 0, 0, 0);
    setStartTime(newTime);
  };
  if (time == null) {
    return <div></div>;
  }
  return (
    <div className={noPrint ? "noPrint" : ""}>
      <div
        style={{
          gap: dense ? 2 : 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <GridSettingsBar_Button
          variant={variant}
          disabled={disabled}
          toolTip={<>Edellinen päivä</>}
          onClick={() => nav1Day(-1)}
          size={size}>
          <ArrowLeftIcon sx={{ fontSize: 40 }} />
          {!dense && <div className="onlyWide1050">{prevText}</div>}
        </GridSettingsBar_Button>
        <GridSettingsBar_Button
          variant={variant}
          disabled={disabled}
          toolTip=""
          onClick={() => setOpen(true)}
          componentProps={{
            style: {
              fontSize: 16,
              width: 80,
            },
          }}
          size={size}>
          <IconWithText IconComponent={CalendarIcon} txt={pvmStringLong(time.starttime)} />
        </GridSettingsBar_Button>
        <DatePicker
          disabled={disabled}
          open={open}
          value={time.starttime}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          onChange={setStartTime}
          sx={{
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            padding: 0,
            border: 0,
          }}
          size={size}
        />
        <GridSettingsBar_Button
          variant={variant}
          disabled={disabled}
          toolTip={null}
          onClick={navToToday}
          size={size}>
          <TodayIcon txt="Tänään" />
        </GridSettingsBar_Button>
        <GridSettingsBar_Button
          variant={variant}
          disabled={disabled}
          toolTip={<>Seuraava päivä</>}
          onClick={() => nav1Day(1)}
          size={size}>
          <ArrowRightIcon sx={{ fontSize: 40 }} />
          {!dense && <div className="onlyWide1050">{nextText}</div>}
        </GridSettingsBar_Button>
      </div>
    </div>
  );
}

GridDateSelector.propTypes = {
  time: PropTypes.object,
  setTime: PropTypes.func,
  dense: PropTypes.bool,
  prevText: PropTypes.string,
  nextText: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  noPrint: PropTypes.bool,
};
